var styles = {"fixedColumnHeader":"TableHeader-module_fixedColumnHeader__WtRmf","columnDivider":"TableHeader-module_columnDivider__wa2uj","invisibleHeader":"TableHeader-module_invisibleHeader__31dSX","text":"TableHeader-module_text__JkgTW","headerText":"TableHeader-module_headerText__8A9E9","content":"TableHeader-module_content__BpzXF"};

export { styles as default };
